/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://j3nj3vwqijdeblfgl4wtbny3ki.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AWS_IAM",
    "aws_cognito_identity_pool_id": "us-east-1:bb98285a-c606-4a34-a119-6ae45c9a5093",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_2WD2L8VXl",
    "aws_user_pools_web_client_id": "5n31371qigb3enb3sqmah1r22",
    "oauth": {
        "domain": "mobile85ba8a8e-85ba8a8e-main.auth.us-east-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/auth/,https://mobile85ba8a8e-85ba8a8e-dev.auth.us-east-1.amazoncognito.com/oauth2/idpresponse/,http://localhost:3000/,https://central.rightoneducation.com/auth/,https://mobile85ba8a8e-85ba8a8e-main.auth.us-east-1.amazoncognito.com/oauth2/idpresponse/",
        "redirectSignOut": "http://localhost:3000/,https://mobile85ba8a8e-85ba8a8e-dev.auth.us-east-1.amazoncognito.com/oauth2/idpresponse/,http://localhost:3000/,https://central.rightoneducation.com/,https://mobile85ba8a8e-85ba8a8e-main.auth.us-east-1.amazoncognito.com/oauth2/idpresponse/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "rightoncentralstorage153119-main",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
